<template>
  <div class="container">
    <b-row>
      <b-col 
        v-if="showSideMenus"
        lg="3" 
        sm="12"         
      >
        <ReverseLogisticsMenu />
        <div v-if="showForms">
          <div class="mt-4">
            <FindCoreCredits :document-number="documentNumber" />
          </div>
          <div class="mt-4">
            <FindEntitlements :oem-part-code="oemPartCode" />
          </div>
        </div>
      </b-col>
      <b-col :class="getContentWidth">
        <router-view />
      </b-col>
    </b-row>
  </div>
</template>
<script>
  import ReverseLogisticsMenu from "@/components/SubMenus/ReverseLogisticsMenu";
  import FindCoreCredits from "@/components/SubMenus/ReverseLogistics/FindCoreCredits";
  import FindEntitlements from "@/components/SubMenus/ReverseLogistics/FindEntitlements";

  export default {
    name: "ReverseLogistics",
    components: { ReverseLogisticsMenu, FindCoreCredits, FindEntitlements },
    data: () => ({
      routesWithoutSideMenus: ["/reverseLogistics/ccrRequestForm", "/reverseLogistics/completeCoreCreditRequest"], 
      routesWithoutForms: ["/reverseLogistics/corePurchaseRequest", "/reverseLogistics/ccrRequestForm"],
      documentNumber: "",
      oemPartCode: ""
    }),
    computed: {
      showSideMenus(){
        return !this.routesWithoutSideMenus.includes(this.$router.currentRoute.path)
      },
      showForms() {     
        return !this.routesWithoutForms.includes(this.$router.currentRoute.path)
      },
      getContentWidth(){
        return `col-sm-12 col-lg-${this.showSideMenus ? "9" : "12"}`
      },
    },
    created () {
      this.documentNumber = this.$route.query["documentNumber"] !== undefined ? this.$route.query["documentNumber"] : "";
      this.oemPartCode = this.$route.query["oemPartCode"] !== undefined ? this.$route.query["oemPartCode"] : "";
    }
  };
</script>